// @flow
import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm, change } from 'redux-form';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux';

import Scrollable from '../shared/Scrollable';
import StyledForm from '../shared/StyledForm';
import Button from '../shared/Button';
import TextInput from '../shared/forms/TextInput';
import Geolocation from '../shared/forms/Geolocation';

const validate = values => {
    const errors = {};

    if (!values.name) {
        errors.name = 'Name is required';
    }

    if (!values.code) {
        errors.code = 'Code is required';
    } else if (values.code.length !== 3) {
        errors.forenames = 'Code length must be 3 characters long';
    }

    if (!values.lat) {
        errors.lat = 'Latitude is required';
    } else if (isNaN(values.lat)) {
        errors.lat = 'Latitude must be a number';
    }

    if (!values.long) {
        errors.long = 'Longitude is required';
    } else if (isNaN(values.long)) {
        errors.long = 'Longitude must be a number';
    }

    return errors;
};

class StationAddForm extends Component {
    updateLocation: Function;

    constructor(props) {
        super(props);

        this.updateLocation = this.updateLocation.bind(this);
    }

    updateLocation(geolocation) {
        this.props.dispatch(
            change(
                'stationAddForm',
                'lat',
                parseFloat(geolocation.lat).toFixed(5)
            )
        );
        this.props.dispatch(
            change(
                'stationAddForm',
                'long',
                parseFloat(geolocation.lng).toFixed(5)
            )
        );
    }

    render() {
        const { handleSubmit, submitting, dirty, error, postcode } = this.props;

        return (
            <StyledForm onSubmit={handleSubmit}>
                <Prompt
                    when={dirty}
                    message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
                />

                <Scrollable additionalClassName="scroll-area">
                    <div className="flex">
                        <div className="col">
                            <Field
                                name="name"
                                label="Name"
                                component={TextInput}
                                error={error}
                            />
                            <Field
                                name="code"
                                label="Code"
                                component={TextInput}
                                error={error}
                            />
                            <Field
                                name="postcode"
                                label="Postcode (Only used to search. You can also drag the marker.)"
                                component={TextInput}
                                error={error}
                            />
                            <Field
                                name="geolocation"
                                component={Geolocation}
                                geocodeSourceValue={postcode}
                                disabled={submitting}
                                onChange={geolocation => {
                                    this.updateLocation(geolocation);
                                }}
                            />
                            <div className="hidden">
                                <Field
                                    name="lat"
                                    label="Latitude"
                                    component={TextInput}
                                    error={error}
                                />
                                <Field
                                    name="long"
                                    label="longitude"
                                    component={TextInput}
                                    error={error}
                                />
                            </div>
                        </div>
                        <div className="col" />
                    </div>
                </Scrollable>

                <div className="sticky-footer">
                    <Button type="submit" disabled={submitting}>
                        Save & Continue
                    </Button>
                </div>
            </StyledForm>
        );
    }
}

const selector = formValueSelector('stationAddForm');

const mapStateToProps = state => {
    const edit = state.stations.edit;

    return {
        station: edit.station,
        postcode: selector(state, 'postcode'),
    };
};

export default reduxForm({
    form: 'stationAddForm',
    validate,
})(connect(mapStateToProps)(StationAddForm));



// WEBPACK FOOTER //
// ./src/components/Stations/Add.js